export default __webpack_public_path__ + "static/media/Astro_Saturn_Black.495da20e.png";